import "./Header.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const Header = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 200) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollDown = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  return (
    <>
      <header className={visible ? "" : "hidden-header"}>
        <div className="link-container">
          <Link to="/" className="header-link">
            Projecten
          </Link>
          <Link to="/about" className="header-link">
            About
          </Link>
          <p className="header-link" onClick={scrollDown}>
            Contact
          </p>
        </div>

        <div className="naam">
          <h1>Rein Brobbel</h1>
          <p>developer</p>
        </div>
        <a
          href="https://gitlab.com/Reinaldinus"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="git-logo"
            src={require("./Assets/gitlab-logo-200.png")}
            alt="Gitlab logo"
          ></img>
        </a>
      </header>
    </>
  );
};

export default Header;
